import { render, staticRenderFns } from "./TextReviewPopup.vue?vue&type=template&id=360a1e1c&scoped=true"
import script from "./TextReviewPopup.vue?vue&type=script&lang=js"
export * from "./TextReviewPopup.vue?vue&type=script&lang=js"
import style0 from "./TextReviewPopup.vue?vue&type=style&index=0&id=360a1e1c&prod&lang=scss"
import style1 from "./TextReviewPopup.vue?vue&type=style&index=1&id=360a1e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a1e1c",
  null
  
)

export default component.exports